<template>
    <div class="card container e2e-not-found">
        <p>
            <b>BUG:</b> Unbekannter UiType '{{fragment.uiType}}'. 
            Fragment kann nicht dargestellt werden.
        </p>
        <code class="card-body">{{JSON.stringify(fragment)}}</code>
    </div>
</template>

<script>
export default {
  name: "fragment-not-found",
  props: ["fragment"]
};
</script>
 

<style scoped>
</style>